import { objectWithoutProperties as _objectWithoutProperties, extends as _extends, taggedTemplateLiteralLoose as _taggedTemplateLiteralLoose } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { Carousel, StyledCarouselScrollContainer, token } from '@zillow/constellation';
import { event } from '@zillow/universal-analytics';
import { usePageProps, getCmsInfoForPage } from '@zillow/zrs-cms';
import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';
import { generateBlockList } from '../../components/BlockList/BlockList.js';

var _excluded = ["slideWidth", "slideGap", "slideAlign", "scrollOffset", "includeSkipLink", "enableSnap", "scrollOffsetMargin"];
var _templateObject;
var CarouselWrapper = /*#__PURE__*/styled(Carousel).withConfig({
  componentId: "sc-1nckztf-0"
})(["", "{", "}"], StyledCarouselScrollContainer, function (props) {
  return props.scrollOffsetMargin && css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n                margin-left: -", "px;\n                margin-right: -", "px;\n            "])), token("spacing." + props.scrollOffset), token("spacing." + props.scrollOffset));
});
var BlockCarousel = function BlockCarousel(props) {
  var attrs = props.attrs,
    index = props.index,
    innerBlocks = props.innerBlocks;
  var pageProps = usePageProps();
  var _attrs$slideWidth = attrs.slideWidth,
    slideWidth = _attrs$slideWidth === void 0 ? 340 : _attrs$slideWidth,
    _attrs$slideGap = attrs.slideGap,
    slideGap = _attrs$slideGap === void 0 ? 'sm' : _attrs$slideGap,
    _attrs$slideAlign = attrs.slideAlign,
    slideAlign = _attrs$slideAlign === void 0 ? 'start' : _attrs$slideAlign,
    _attrs$scrollOffset = attrs.scrollOffset,
    scrollOffset = _attrs$scrollOffset === void 0 ? 0 : _attrs$scrollOffset,
    _attrs$includeSkipLin = attrs.includeSkipLink,
    includeSkipLink = _attrs$includeSkipLin === void 0 ? true : _attrs$includeSkipLin,
    _attrs$enableSnap = attrs.enableSnap,
    enableSnap = _attrs$enableSnap === void 0 ? false : _attrs$enableSnap,
    _attrs$scrollOffsetMa = attrs.scrollOffsetMargin,
    scrollOffsetMargin = _attrs$scrollOffsetMa === void 0 ? false : _attrs$scrollOffsetMa,
    restAttrs = _objectWithoutProperties(attrs, _excluded);
  var headingCarouselInnerBlocks = innerBlocks.find(function (block) {
    return block.blockName === 'constellation/carousel-v2-heading';
  });
  var carouselSlidesInnerBlocks = innerBlocks.find(function (block) {
    return block.blockName === 'constellation/carousel-v2-slides';
  });
  var handleNavigationEvent = function handleNavigationEvent(navigation) {
    event({
      // https://dataportal.zillowgroup.net/event-registry/2048
      envelope: {
        event_type_id: '2048',
        event_type_version_id: '3',
        event_template_id: '126',
        event_template_version_id: '1'
        // Master ID: 2284.2.126.1
      },
      clickstream_trigger: {
        trigger_type_nm: 'interaction',
        trigger_location_nm: 'cms',
        trigger_source_nm: 'cms_carousel',
        trigger_object_nm: 'no_trigger_object'
      },
      semantic: {
        semantic_event_nm: 'cms_click'
      },
      cms_info: Object.assign({
        block_id: (attrs === null || attrs === void 0 ? void 0 : attrs.id) || '',
        block_type_cd: 'carousel',
        block_displayed_txt: navigation
      }, getCmsInfoForPage(pageProps))
    });
  };
  return /*#__PURE__*/React.createElement(CarouselWrapper, _extends({
    key: index,
    slideWidth: slideWidth,
    slideGap: slideGap,
    slideAlign: slideAlign,
    scrollOffset: scrollOffset,
    scrollOffsetMargin: scrollOffsetMargin,
    includeSkipLink: includeSkipLink,
    enableSnap: enableSnap,
    heading: generateBlockList({
      blocks: headingCarouselInnerBlocks === null || headingCarouselInnerBlocks === void 0 ? void 0 : headingCarouselInnerBlocks.innerBlocks
    }),
    onNextClick: function onNextClick() {
      handleNavigationEvent('next');
    },
    onPreviousClick: function onPreviousClick() {
      handleNavigationEvent('previous');
    }
  }, restAttrs), generateBlockList({
    blocks: carouselSlidesInnerBlocks === null || carouselSlidesInnerBlocks === void 0 ? void 0 : carouselSlidesInnerBlocks.innerBlocks
  }));
};
BlockCarousel.propTypes = process.env.NODE_ENV !== "production" ? {
  attrs: PropTypes.shape({
    slideWidth: PropTypes.string,
    slideGap: PropTypes.string,
    slideAlign: PropTypes.string,
    scrollOffset: PropTypes.string,
    includeSkipLink: PropTypes.bool,
    enableSnap: PropTypes.bool
  }),
  index: PropTypes.number
} : {};
var CarouselV2 = BlockCarousel;

export { CarouselV2 as default };
